import axios from "axios";
import {LINKS} from "./App";


export const siteData = {
    state: null,
    reducers: {
        setSiteData(_, payload) {
            return payload
        }
    },
    effects: (dispatch) => ({
        async fetchSiteData({server, lang}) {
            const res = await axios.get(`${LINKS.filesUrl}/configs/${server}-${lang}.json`)
            dispatch.siteData.setSiteData(res.data)
            return res
        },
    }),
};

export const serversData = {
    state: null,
    reducers: {
        setServersData(_, payload) {
            return payload
        }
    },
    effects: (dispatch) => ({
        async fetchServersData() {
            const res = await axios.get(`${LINKS.filesUrl}/configs/servers.json`)
            dispatch.serversData.setServersData(res.data)
            return res
        },
    }),
};

export const skillsJsonState = {
    state: null,
    reducers: {
        setSkills(_, payload) {
            return payload
        }
    },
    effects: (dispatch) => ({
        async fetchSkills() {
            const res = await axios.get('https://new.dares.club/database/skills.json')
            dispatch.skillsJsonState.setSkills(res.data)
            return res
        },
    }),
};

export const setsJsonState = {
    state: null,
    reducers: {
        setSets(state, payload) {
            return payload
        }
    },
    effects: (dispatch) => ({
        async fetchSets() {
            const res = await axios.get('https://new.dares.club/database/sets.json')
            dispatch.setsJsonState.setSets(res.data)
            return res
        },
    }),
};

export const itemsJsonState = {
    state: null,
    reducers: {
        setItems(state, payload) {
            return payload
        }
    },
    effects: (dispatch) => ({
        async fetchItems() {
            axios.get('https://new.dares.club/database/items.json').then(r => {
                dispatch.itemsJsonState.setItems(r.data)
                return r.data
            })
        },
    }),
};
